import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { referralSources, site } from '../data/site';
interface ContactFormProps {
  prefillMessage: string;
}
const inputClass = 'w-full rounded-sm border border-white/20 bg-white/5 px-4 py-3.5 text-[14px] text-white placeholder-white/40 outline-none transition-colors duration-150 ease-smooth focus:border-gold-400';
export function ContactForm({
  prefillMessage
}: ContactFormProps) {
  const [mensaje, setMensaje] = useState('');
  const [sent, setSent] = useState(false);
  useEffect(() => {
    if (prefillMessage) {
      setMensaje(prefillMessage);
      setSent(false);
    }
  }, [prefillMessage]);
  return <section id="contacto" className="bg-forest-900 py-20 lg:py-28" data-id="element-30" data-mp="h1w6t69k9wya">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-[1fr_1.15fr] lg:gap-20 lg:px-8" data-id="element-31" data-mp="3phy2jjnhmptp">
        <div data-id="element-32" data-mp="3kjwfyoqus8dh">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold-400" data-id="element-33" data-mp="3kid0h0d0u1cr">
            Contacto
          </p>
          <h2 className="mt-3 font-display text-3xl leading-tight text-white md:text-[42px]" data-id="element-34" data-mp="3uk00rshbfm4a">
            Reserve su lote hoy con Q10,000
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-white/70" data-id="element-35" data-mp="363wf266ajr0">
            Déjenos sus datos y un asesor de {site.empresa} lo contacta en menos de una hora con
            disponibilidad real, plano actualizado y opciones de pago.
          </p>

          <ul className="mt-10 space-y-5 text-[14px] text-white/80" data-id="element-36" data-mp="3bkvtao5fa0eq">
            <li className="flex items-start gap-3" data-id="element-37" data-mp="3bn8hhj1rx708">
              <PhoneIcon size={18} className="mt-0.5 shrink-0 text-gold-400" data-id="element-38" data-mp="3gjp76homftff" />
              {site.telefono}
            </li>
            <li className="flex items-start gap-3" data-id="element-39" data-mp="3kneu72pne2yc">
              <MailIcon size={18} className="mt-0.5 shrink-0 text-gold-400" data-id="element-40" data-mp="vv15ceohv473" />
              {site.email}
            </li>
            <li className="flex items-start gap-3" data-id="element-41" data-mp="zujp374kx98c">
              <MapPinIcon size={18} className="mt-0.5 shrink-0 text-gold-400" data-id="element-42" data-mp="2wwh4nzic9kwp" />
              {site.direccion}
            </li>
          </ul>
        </div>

        <div className="rounded-sm border border-white/12 bg-white/[0.04] p-7 sm:p-9" data-id="element-43" data-mp="2rww5bnz9bajg">
          {sent ? <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col items-center justify-center py-12 text-center" role="status" data-id="element-44" data-mp="35wdzkivbng07">
              <CheckCircle2Icon size={54} className="text-gold-400" strokeWidth={1.4} data-id="element-45" data-mp="2myb53ok08qv0" />
              <p className="mt-6 font-display text-3xl text-white" data-id="element-46" data-mp="2n05tjcuhj13u">¡Solicitud enviada!</p>
              <p className="mt-3 max-w-sm text-[14px] leading-relaxed text-white/70" data-id="element-47" data-mp="2i5i152wd1mjz">
                Un asesor de {site.empresa} lo contactará en menos de 1 hora. Si desea atención
                inmediata, escríbanos por WhatsApp al {site.whatsapp}.
              </p>
              <button type="button" onClick={() => setSent(false)} className="mt-8 text-[12px] font-semibold uppercase tracking-[0.14em] text-gold-400 underline-offset-4 hover:underline" data-id="element-48" data-mp="503amyoav63c">
                Enviar otra solicitud
              </button>
            </motion.div> : <form className="space-y-5" onSubmit={event => {
          event.preventDefault();
          setSent(true);
        }} data-id="element-49" data-mp="op5acbwmm5m1">
              <div data-id="element-50" data-mp="eqoep1mqt2tn">
                <label htmlFor="nombre" className="mb-2 block text-[12px] uppercase tracking-[0.12em] text-white/60" data-id="element-51" data-mp="er7nnsuf0gvj">
                  Nombre completo
                </label>
                <input id="nombre" name="nombre" required placeholder="Ej. Ana Lucía Morales" className={inputClass} data-id="element-52" data-mp="2zgx1q3nanyn6" />
              </div>

              <div className="grid gap-5 sm:grid-cols-2" data-id="element-53" data-mp="34h1h1qcgunbt">
                <div data-id="element-54" data-mp="3jpn4lf8yavj9">
                  <label htmlFor="telefono" className="mb-2 block text-[12px] uppercase tracking-[0.12em] text-white/60" data-id="element-55" data-mp="3jq6j0lze71sj">
                    Teléfono
                  </label>
                  <input id="telefono" name="telefono" type="tel" required placeholder="5555 1234" className={inputClass} data-id="element-56" data-mp="3axctzwu58o1h" />
                </div>
                <div data-id="element-57" data-mp="6gsg7cctyks4">
                  <label htmlFor="email" className="mb-2 block text-[12px] uppercase tracking-[0.12em] text-white/60" data-id="element-58" data-mp="2ht3v6orrlqn">
                    Email
                  </label>
                  <input id="email" name="email" type="email" required placeholder="correo@ejemplo.com" className={inputClass} data-id="element-59" data-mp="3tpxh0xn5vyxd" />
                </div>
              </div>

              <div data-id="element-60" data-mp="2dbxinr3yshc8">
                <label htmlFor="origen" className="mb-2 block text-[12px] uppercase tracking-[0.12em] text-white/60" data-id="element-61" data-mp="235wbdgzgvxes">
                  ¿Cómo nos conociste?
                </label>
                <select id="origen" name="origen" required defaultValue="" className={inputClass} data-id="element-62" data-mp="282efqfqvxtql">
                  <option value="" disabled data-id="element-63" data-mp="2huk2nb2a5kyx">
                    Seleccione una opción
                  </option>
                  {referralSources.map(source => <option key={source} value={source} className="text-forest-900" data-id="element-64" data-mp="2lvvvrqkd4obv">
                      {source}
                    </option>)}
                </select>
              </div>

              <div data-id="element-65" data-mp="2vs8nwk09eu4i">
                <label htmlFor="mensaje" className="mb-2 block text-[12px] uppercase tracking-[0.12em] text-white/60" data-id="element-66" data-mp="30tehek1qulf3">
                  Mensaje
                </label>
                <textarea id="mensaje" name="mensaje" rows={4} value={mensaje} onChange={e => setMensaje(e.target.value)} placeholder="Cuéntenos qué lote le interesa o qué cuota busca." className={`${inputClass} resize-none`} data-id="element-67" data-mp="11i5160svdyet" />
              </div>

              <button type="submit" className="w-full rounded-full bg-gold px-6 py-4 text-[12px] font-semibold uppercase tracking-[0.14em] text-white transition-[background-color,transform] duration-150 ease-smooth hover:bg-gold-600 active:scale-[0.99]" data-id="element-68" data-mp="18eg9hwykh5ig">
                Enviar y ser contactado en menos de 1 hora
              </button>
            </form>}
        </div>
      </div>
    </section>;
}